import React from 'react';

import { Box, Center, Flex, HStack, Text } from '@chakra-ui/react';

import { Select, SelectProps } from 'components/DataEntry';

interface Props {
  name: string;
  label?: string;
  isRequired?: boolean;
  quantifier?: SelectProps;
  customQuantifier?: React.ReactNode;
}

export const ConditionLabel = (props: Props) => {
  const { name, label, isRequired, quantifier, customQuantifier } = props;
  return (
    <HStack>
      <Flex justify="flex-start">
        <Box
          px={2}
          py={1}
          bg="primary"
          color="white"
          borderRadius={6}
          minW={6}
          fontSize="14px"
        >
          <Center>{name}</Center>
        </Box>
      </Flex>
      {customQuantifier}
      {quantifier && (
        <Box w={24}>
          <Select {...quantifier} />
        </Box>
      )}
      {label && (
        <HStack spacing={0}>
          <Box>{label}</Box>
          {isRequired && <Text color="red">*</Text>}
        </HStack>
      )}
    </HStack>
  );
};
